export class SwrError extends Error {
  readonly message: string;
  readonly statusCode?: number;

  constructor(message: string, error: unknown);
  constructor(message: string, statusCode: number);

  constructor(message: string, arg: number | unknown) {
    super(message);

    this.message = message;

    if (typeof arg === "number") {
      this.statusCode = arg;
    } else {
      this.cause = arg;
    }
  }
}
